export const resources = {
  SETTINGS_USERS: 'settings.users',
  SETTINGS_ROLES: 'settings.roles',
  SETTINGS_CACHES: 'settings.caches',
  SETTINGS_ACTIVITY_LOG: 'settings.activitylog',
  SETTINGS_USER_CHANGE_ROLE: 'settings.user.change.role',
  CUSTOMERS: 'customers',
  CUSTOMERS_DEACTIVATE: 'customers.deactivate',
  CUSTOMERS_ASSOCIATION: 'customers.association',
  CUSTOMERS_AGENT_LOGS: 'customers.agentLogs',
  CUSTOMER_TEAM_SUPPORT: 'customer.team.support',
  CUSTOMER_TEAM_ROLE_UPDATE: 'customer.team.role.update',
  CUSTOMER_TEAM_ENABLE_DB_ACCESS: 'customer.team.enable-db-access',
  RD_NETWORKS: 'rd.networks',
  RD_APPLICATIONS: 'rd.applications',
  CANCELLATIONS_REQUEST: 'cancellation.request',
  TENANT_SENSITIVE_DATA: 'tenant.sensitive.data',
  TENANT_LICENSING_DATA: 'tenant.licensing.data',
  CS_CUSTOMER_ENV_FEATURE_ENABLE: 'cs.customer.env.feature.enable',
  CLOUD_MANAGEMENT: 'cloud.management',
  CLOUD_MANAGEMENT_RESIZE_SUPREME: 'cloud.management.resize.supreme',
  SATISFACTION_BOARD: 'satisfaction.board',
  QBR_BOARD: 'qbr.board',
  RD_MAINTENANCE: 'rd.maintenance',
  SENTIMENT_BOARD: 'sentiment.board',
  CS_AGENT_ROLLOUT: 'cs.agent.rollout',
  CS_AGENT_ROLLOUT_TRACK: 'cs.agent.rollout.track',
  CS_NETWORK_ROLLOUT: 'cs.network.rollout',
  PRODUCT_FEATURE_FLAG: 'product.fflag',
  PRODUCT_FEATURE_FLAG_LOGS: 'product.fflag.logs',
  MRR_ACTIVITY: 'mrr.activity',
  NETWORK_EDGE: 'network.edge',
  COPILOT_CHAT: 'copilot.chat'
};

export const access = {
  WRITE: 'write',
  READ: 'read',
  EXPORT: 'export',
  DELETE: 'delete'
};

let userPermissions: any = null;

export function setUserPermissions(permissions: string[] | string) {
  const formattedPermissions = Array.isArray(permissions)
    ? permissions
    : permissions.split(',');
  userPermissions = new Map(formattedPermissions.map(p => [p, true]));
}

type Rules = [string, string][];

export function hasAccess(...rules: Rules): boolean {
  return rules.every(([resource, access]) => {
    const permission = `${resource}:${access}`;
    return userPermissions?.has(permission);
  });
}
